import { useEffect } from "react";
import { IoPersonCircle } from "react-icons/io5";
import { IoCall } from "react-icons/io5";
import { formatDate } from "../utils/Helpers";
import { useCallContext } from "../callContext/callContext";
import { useMainContext } from "../callContext/MainContext";
import {RecentText as text} from "../database/Text";
const Recent = () => {
  const {language}=useMainContext();
  const { callInfoApi, callsList, setCallsList } =
    useCallContext();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  console.log("The callsList is:::", callsList);
  const handleCallClick = (item, i) => {
    console.log(item);
    callInfoApi(i, item.phone, "Recent");
    console.log("i", i);
    const newCall = {
      call: { ...item, time: formatDate(new Date()) },
      avatar: i,
    };
    setCallsList((oldList) => [newCall, ...oldList]);
    localStorage.setItem("callsList", JSON.stringify(callsList));
  };
  useEffect(() => {
    if (callsList.length > 10) {
      console.log("reducing the list to 10 objects");
      console.log(callsList);
      const cpyArray = [...callsList];
      cpyArray.splice(10, 1);
      console.log("list is:::", cpyArray);
      setCallsList(cpyArray);
    }
    localStorage.setItem("callsList", JSON.stringify(callsList));
  }, [callsList]);
  if(callsList.length > 0)
  {
    return    <div className="pt-2 overflow-y-scroll fadeInOut min-h-screen">
          {callsList.length > 0 && 
          callsList.map((item, index) => {
            const { call, avatar } = item;
            return (
              <div
                key={index}
                className="border-b-2 border-gray-400 w-full flex p-3 pl-6 pr-8 justify-end"
              >
                <div className="w-1/12 m-auto">
                  <IoPersonCircle size={50} />
                </div>
                <div className="flex flex-col text-gray-400 w-5/6 ml-6 ">
                  <div>{call.phone}</div>
                  <div>{call.time}</div>
                </div>
                <div className="w-1/12 m-auto ">
                  <IoCall
                    size={40}
                    color="gray"
                    onClick={() => handleCallClick(call, avatar)}
                  />
                </div>
              </div>
              )})}
              </div>
  }
  if(callsList.length==0)
  {
   return  <div className="overflow-y-scroll fadeInOut z-[2000] min-h-screen flex flex-col justify-center items-center ">
      <div className=" cursor-pointer -translate-y-1/2 -mt-16">
        {text?.noCallsText?.[language]}
      </div>
   </div>
  }
};

export default Recent;
